import { render, staticRenderFns } from "./PopupHabitsEdit.vue?vue&type=template&id=d0ebe0a6"
import script from "./PopupHabitsEdit.vue?vue&type=script&lang=js"
export * from "./PopupHabitsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports